import { useEffect, useState } from "react";
import { X } from "lucide-react";
import api from "@/lib/api";

export default function PromoBanner() {
  const [banners, setBanners] = useState([]);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get("/banners").then(({ data }) => setBanners(data.banners || [])).catch(() => {});
  }, []);

  const banner = banners[0];
  useEffect(() => {
    if (banner) setDismissed(sessionStorage.getItem(`promo_${banner.id}`) === "1");
  }, [banner]);

  if (!banner || dismissed) return null;

  const close = () => { sessionStorage.setItem(`promo_${banner.id}`, "1"); setDismissed(true); };

  return (
    <div className="w-full bg-[#1f5d3a] text-white" data-testid="promo-banner">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-3 px-5 py-2 text-center text-sm md:px-8">
        <p className="truncate">
          <span className="font-semibold">{banner.title}</span>
          {banner.subtitle && <span className="hidden text-[#cfe6d9] sm:inline"> — {banner.subtitle}</span>}
        </p>
        {banner.cta_label && banner.cta_link && (
          <a href={banner.cta_link} data-testid="promo-cta"
            className="shrink-0 rounded-full bg-[#d46a1d] px-3 py-1 text-xs font-semibold text-white hover:bg-[#c05f16]">
            {banner.cta_label}
          </a>
        )}
        <button onClick={close} data-testid="promo-close" className="absolute right-4 text-white/80 hover:text-white md:static">
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
